import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "../../../../components/form/controls/Controls";
import ContextPropInput from "../ContextPropInput/ContextPropInput";

const slotTypeOption = [
  {
    id: "number",
    name: "Number",
  },
  {
    id: "string",
    name: "String",
  },
  {
    id: "object",
    name: "Object",
  },
];

const ContextSlotInPut = ({ addOrEdit, contextSlots, handleDeleteSlot }) => {
  const [slotList, setSlotList] = useState([]);

  useEffect(() => {
    setSlotList([...contextSlots.filter((slot) => slot.name !== "value")]);
  }, [contextSlots]);

  const handleSlotChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...slotList];
    list[index][name] = value;
    setSlotList(list);
  };

  const handleSlotRemove = (index) => {
    const list = [...slotList];

    if (list[index]["id"]) {
      handleDeleteSlot(list[index]);
    } else {
      list.splice(index, 1);
      setSlotList(list);
    }
  };

  const handleSlotAdd = () => {
    setSlotList([
      ...slotList,
      { id: "", name: "", type: "", ttsContextId: "", props: "" },
    ]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    addOrEdit(slotList);
  };

  const updateProps = (index, props) => {
    const list = [...slotList];
    list[index]["props"] = props;
    setSlotList(list);
  };

  return (
    <form onSubmit={onSubmit} style={{ width: "50%" }} autoComplete="off">
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5>slot config</h5>
          <Controls.Button
            variant="outlined"
            text="Add Slot"
            startIcon={<AddIcon />}
            onClick={handleSlotAdd}
          />
        </div>
        {slotList.map((slot, index) => (
          <div
            key={index}
            style={{
              border: "dashed 1px",
              margin: "10px 0 10px 0",
              padding: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Controls.Input
                name="name"
                value={slot.name}
                label={`slot ${index + 1}`}
                type="text"
                style={{ marginRight: "10px" }}
                onChange={(e) => handleSlotChange(e, index)}
              />

              <Controls.Select
                name="type"
                label="Type"
                value={slot.type}
                onChange={(e) => handleSlotChange(e, index)}
                options={slotTypeOption}
              />

              <Controls.Button
                variant="outlined"
                text="remove"
                color="error"
                // startIcon={<ClearIcon />}
                onClick={() => handleSlotRemove(index)}
              />

              {/* <div>add prop</div> */}
            </div>
            {slot.type === "object" ? (
              <ContextPropInput
                slot={{ ...slot }}
                updateProps={(props) => updateProps(index, props)}
              />
            ) : null}
          </div>
        ))}
        <Controls.Button
          sx={{ width: "100%", marginTop: "10px" }}
          type="submit"
          text="Submit"
          disabled={!slotList.length}
        />
      </div>
    </form>
  );
};

export default ContextSlotInPut;
